import {
    fetchProductHotel as apiFetchProductHotel,
    addProductHotel as apiAddProductHotel,
    updateProductHotel as apiUpdateProductHotel,
    deleteProductHotel as apiDeleteProductHotel,
} from '../../api/productHotel'; // Pastikan untuk mengimpor fungsi yang benar

// Action Types
export const FETCH_PRODUCT_HOTEL_REQUEST = 'FETCH_PRODUCT_HOTEL_REQUEST';
export const FETCH_PRODUCT_HOTEL_SUCCESS = 'FETCH_PRODUCT_HOTEL_SUCCESS';
export const FETCH_PRODUCT_HOTEL_FAILURE = 'FETCH_PRODUCT_HOTEL_FAILURE';
export const ADD_PRODUCT_HOTEL_REQUEST = 'ADD_PRODUCT_HOTEL_REQUEST';
export const ADD_PRODUCT_HOTEL_SUCCESS = 'ADD_PRODUCT_HOTEL_SUCCESS';
export const ADD_PRODUCT_HOTEL_FAILURE = 'ADD_PRODUCT_HOTEL_FAILURE';
export const UPDATE_PRODUCT_HOTEL_REQUEST = 'UPDATE_PRODUCT_HOTEL_REQUEST';
export const UPDATE_PRODUCT_HOTEL_SUCCESS = 'UPDATE_PRODUCT_HOTEL_SUCCESS';
export const UPDATE_PRODUCT_HOTEL_FAILURE = 'UPDATE_PRODUCT_HOTEL_FAILURE';
export const DELETE_PRODUCT_HOTEL_REQUEST = 'DELETE_PRODUCT_HOTEL_REQUEST';
export const DELETE_PRODUCT_HOTEL_SUCCESS = 'DELETE_PRODUCT_HOTEL_SUCCESS';
export const DELETE_PRODUCT_HOTEL_FAILURE = 'DELETE_PRODUCT_HOTEL_FAILURE';

// Action Creators
export const fetchProductHotelRequest = () => ({
    type: FETCH_PRODUCT_HOTEL_REQUEST,
});

export const fetchProductHotelSuccess = (products) => ({
    type: FETCH_PRODUCT_HOTEL_SUCCESS,
    payload: products,
});

export const fetchProductHotelFailure = (error) => ({
    type: FETCH_PRODUCT_HOTEL_FAILURE,
    payload: error,
});

export const addProductHotelRequest = () => ({
    type: ADD_PRODUCT_HOTEL_REQUEST,
});

export const addProductHotelSuccess = (product) => ({
    type: ADD_PRODUCT_HOTEL_SUCCESS,
    payload: product,
});

export const addProductHotelFailure = (error) => ({
    type: ADD_PRODUCT_HOTEL_FAILURE,
    payload: error,
});

export const updateProductHotelRequest = () => ({
    type: UPDATE_PRODUCT_HOTEL_REQUEST,
});

export const updateProductHotelSuccess = (product) => ({
    type: UPDATE_PRODUCT_HOTEL_SUCCESS,
    payload: product,
});

export const updateProductHotelFailure = (error) => ({
    type: UPDATE_PRODUCT_HOTEL_FAILURE,
    payload: error,
});

export const deleteProductHotelRequest = () => ({
    type: DELETE_PRODUCT_HOTEL_REQUEST,
});

export const deleteProductHotelSuccess = (id) => ({
    type: DELETE_PRODUCT_HOTEL_SUCCESS,
    payload: id,
});

export const deleteProductHotelFailure = (error) => ({
    type: DELETE_PRODUCT_HOTEL_FAILURE,
    payload: error,
});

// Thunks
export const fetchProductHotel = () => async (dispatch) => {
    dispatch(fetchProductHotelRequest());
    try {
        const products = await apiFetchProductHotel();
        dispatch(fetchProductHotelSuccess(products.data));
    } catch (error) {
        dispatch(fetchProductHotelFailure(error.message));
    }
};

export const addProductHotel = (product) => async (dispatch) => {
    dispatch(addProductHotelRequest());
    try {
        const newProduct = await apiAddProductHotel(product);
        dispatch(addProductHotelSuccess(newProduct));
    } catch (error) {
        dispatch(addProductHotelFailure(error.message));
    }
};

export const updateProductHotel = (id, product) => async (dispatch) => {
    dispatch(updateProductHotelRequest());
    try {
        const updatedProduct = await apiUpdateProductHotel(id, product);
        dispatch(updateProductHotelSuccess(updatedProduct));
    } catch (error) {
        dispatch(updateProductHotelFailure(error.message));
    }
};

export const deleteProductHotel = (id) => async (dispatch) => {
    dispatch(deleteProductHotelRequest());
    try {
        await apiDeleteProductHotel(id);
        dispatch(deleteProductHotelSuccess(id));
    } catch (error) {
        dispatch(deleteProductHotelFailure(error.message));
    }
};
